import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { buildCategoryLabelMapsLookup } from './reportingCategoryLabelMaps';

/** Enabled dimension maps for chart label rewriting. */
export default function useCategoryLabelMaps() {
    const items = useSelector(s => s.reportCategoryLabelMapList?.items ?? []);
    return useMemo(() => buildCategoryLabelMapsLookup(items), [items]);
}
